import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Grid} from "@mui/material";
import { CardActionArea } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useApp } from "../../../../hooks/useApp";

export default function FeatureCard({ asset }) {
  const { setSelectedAsset } = useApp();
  const theme = useTheme();
  const handleCardClick = (value) => {
    setSelectedAsset(value);
  };
  return (
    <Grid
      container
      maxWidth={380}
      borderRadius={"8px 0px 0px 0px"}
      position={"relative"}
    >
      <Grid item>
        <svg
          width={15}
          id="topper-notch"
          viewBox="0 0 42 152"
          overflow={"hidden"}
          style={{ borderRadius: "8px 0 0 0" }}
        >
          <path
            d="M41 0H40H1H0V96.5C0 101.6 2 106.3 5.6 109.9L35 139.4C38.2 142.6 40 146.9 40 151.4H41H42V0H41Z"
            fill={theme.palette.primary.main}
          ></path>
          <path
            d="M35.7 138.7L6.3 109.3C2.9 105.9 1 101.3 1 96.6V0H0V96.5C0 101.6 2 106.3 5.6 109.9L35 139.4C38.2 142.6 40 146.9 40 151.4H41C41 146.7 39.1 142.1 35.7 138.7Z"
            fill={theme.palette.primary.main}
          ></path>
        </svg>
      </Grid>
      <Grid xs item maxWidth={345}>
        <Card
          sx={{
            boxShadow: "none",
            overflow: "hidden",
            borderRadius: "0px 8px 8px 8px",
          }}
        >
          <CardActionArea onClick={() => handleCardClick(asset)}>
            <Grid
              item
              container
              xs={12}
              sx={{ backgroundColor: "primary.main" }}
              height={"60px"}
              alignItems={"top"}
              justifyContent={"space-between"}
            >
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="div"
                  color="customColors.white"
                  overflow={"hidden"}
                >
                  {asset.Title}
                </Typography>
              </CardContent>
            </Grid>
            <Grid></Grid>
            <Grid
              item
              xs={12}
              sx={{
                backgroundColor: "secondary.main",
                boxShadow: "0 4px 8px rbga(0,0,0,.8)",
              }}
              className="toBottomGradient"
            >
              <CardMedia
                sx={{ height: 260, margin: "auto" }}
                image={asset.Image}
                title={asset.Title}
                style={{
                  backgroundSize: "cover", // or 'contain'
                  backgroundPosition: "center", // you can adjust this based on your preference
                }}
              />
            </Grid>
          </CardActionArea>
        </Card>
      </Grid>
    </Grid>
  );
}
